import './ProductReviewGraph.style';

import { PureComponent } from 'react';

export class ProductReviewGraph extends PureComponent {
    render() {
        const { stars, total_votes } = this.props;

        if (!stars) {
            return null;
        }

        return (
            <div block="ProductReviewGraph">
                { stars.map((reviewGraphItem, index) => {
                    const { rating: rating_value, score: rating_count } = reviewGraphItem;

                    const ONE_FIFTH_OF_A_HUNDRED = 20;
                    const ONE_HUNDRED_PERCENT = 100;
                    const stars = parseFloat(rating_value / ONE_FIFTH_OF_A_HUNDRED);
                    const percentOfVotes = Math.round((rating_count / total_votes) * ONE_HUNDRED_PERCENT * 10) / 10;

                    return (
                        <div block="ProductReviewGraph" elem="Bar" key={ index }>
                            <span>{ __('%s stars', stars) }</span>
                            <div style={ { '--percentage': `${ percentOfVotes }%` } } />
                            <span>{ __('%s%', percentOfVotes || '0') }</span>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default ProductReviewGraph;
